import { useI18n } from "@wato/i18n/react";
import { IconButton, SparklesIcon } from "@wato/ui";
import { useLocation } from "react-router";
import { isAssistantFabHidden } from "./assistant-visibility";
import { useOwnerAssistant } from "./OwnerAssistantProvider";

/**
 * OWN-318: icon-only round button, stacked above the support button (and above the mobile bottom bar).
 * The dot shows unread summaries / questions / proposals.
 */
export function OwnerAssistantFab() {
  const { t } = useI18n();
  const { pathname } = useLocation();
  const { open, setOpen, unread } = useOwnerAssistant();
  if (isAssistantFabHidden(pathname)) return null;
  const label = t("dashboard.ownerAssistant.title");
  return (
    <div className="fixed end-4 z-40 bottom-[calc(9rem+env(safe-area-inset-bottom))] md:bottom-20">
      <IconButton
        variant="primary"
        label={label}
        icon={<SparklesIcon className="size-5" />}
        data-testid="assistant-fab"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
        className="size-11! rounded-full! shadow-lg"
      />
      {unread > 0 && (
        <span
          aria-hidden="true"
          data-testid="assistant-fab-dot"
          className="absolute -top-0.5 -end-0.5 size-3 rounded-full border-2 border-surface bg-danger-bg"
        />
      )}
    </div>
  );
}
